import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, SelectionButton, SortDialog, Title } from './SearchOrderDialog.styles';
import SvgClose from '../../../../../play-core/icons/Close';
import { Colors } from '../../../../../play-core/styles/Colors';
import { RemixFocusLock } from '../../../components/ClientOnly/ClientOnly';
import { useOneWayTimeoutToggle } from '../../../components/Collapsible/use-one-way-timeout-toggle';
import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchOrderDialog = ({
  selected,
  items,
  show,
  onCloseClick,
  onSelection
}) => {
  const {
    t
  } = useTranslation();
  const visibility = useOneWayTimeoutToggle(['visible', 'hidden'], !show, 400);
  return /*#__PURE__*/_jsx(SortDialog, {
    show: show,
    style: {
      visibility
    },
    children: /*#__PURE__*/_jsxs(RemixFocusLock, {
      children: [/*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: t('search.orderBy')
        }), /*#__PURE__*/_jsx("button", {
          "aria-label": t('global.close'),
          onClick: onCloseClick,
          children: /*#__PURE__*/_jsx(IconWrapper, {
            icon: /*#__PURE__*/_jsx(SvgClose, {}),
            color: Colors.WHITE
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: items.map(value => /*#__PURE__*/_jsx(SelectionButton, {
          type: "text",
          text: value.title,
          onClick: () => onSelection(value.id),
          isActive: selected?.id === value.id,
          leftAligned: true,
          expand: true
        }, value.id))
      })]
    })
  });
};